import path from 'path';
import {wrapAddPanelIcon} from '@packages/systems/ui/shared-ui/wrapAddPanelIcon';
import {
  AddPanelForm64Icon,
  AddPanelLabel64Icon,
  AddPanelFormCheckbox64Icon,
  AddPanelFormFileUpload64Icon,
  AddPanelFormInput64Icon,
  AddPanelFormRadio64Icon,
  AddPanelFormTextarea64Icon,
  AddPanelFormSelect64Icon,
  AddPanelFormRecaptcha64Icon,
  AddPanelFormSubmit64Icon,
  ElementFormBlockIcon as FormIcon,
  ElementCheckboxIcon as CheckboxIcon,
  ElementInputIcon as InputIcon,
  ElementRadioIcon as RadioIcon,
  ElementreCAPTCHAIcon as ReCaptchaIcon,
  ElementSelectIcon as SelectIcon,
  ElementTextAreaIcon as FormTextareaIcon,
  UploadIcon,
} from '@packages/systems/spring';
import FormBlockLabel from './FormBlockLabel';
import FormButton from './FormButton';
import FormButtonComponent from './FormButtonComponent';
import FormCheckboxInput from './FormCheckboxInput';
import FormCheckboxWrapper from './FormCheckboxWrapper';
import FormErrorMessage from './FormErrorMessage';
import FormForm from './FormForm';
import FormInlineLabel from './FormInlineLabel';
import FormRadioInput from './FormRadioInput';
import FormRadioWrapper from './FormRadioWrapper';
import FormSelect from './FormSelect';
import FormSuccessMessage from './FormSuccessMessage';
import FormTextarea from './FormTextarea';
import FormTextInput from './FormTextInput';
import FormWrapper from './FormWrapper';
import FormReCaptcha from './FormReCaptcha';
import FormFileUploadWrapper from './FormFileUploadWrapper';
import FormFileUploadDefault from './FormFileUploadDefault';
import FormFileUploadUploading from './FormFileUploadUploading';
import FormFileUploadUploadingBtn from './FormFileUploadUploadingBtn';
import FormFileUploadUploadingIcon from './FormFileUploadUploadingIcon';
import FormFileUploadSuccess from './FormFileUploadSuccess';
import FormFileUploadFile from './FormFileUploadFile';
import FormFileUploadFileName from './FormFileUploadFileName';
import FormFileUploadRemoveLink from './FormFileUploadRemoveLink';
import FormFileUploadError from './FormFileUploadError';
import FormFileUploadErrorMsg from './FormFileUploadErrorMsg';
import UserFormUploadErrorMsg from './UserFormUploadErrorMsg';
import FormFileUploadInput from './FormFileUploadInput';
import FormFileUploadLabel from './FormFileUploadLabel';
import FormFileUploadInfo from './FormFileUploadInfo';
import FormFileUploadText from './FormFileUploadText';
import FormFormType from './dataTypes/FormFormType';
import FormFormChildrenType from './dataTypes/FormFormChildrenType';
import FormSelectType from './dataTypes/FormSelectType';
import UserFormSelectType from './dataTypes/UserFormSelectType';
import FormSelectOption from './dataTypes/FormSelectOption';
import FormTextInputType from './dataTypes/FormTextInputType';
import UserFormTextInputType from './dataTypes/UserFormTextInputType';
import FormTextAreaType from './dataTypes/FormTextAreaType';
import FormFileUploadType from './dataTypes/FormFileUploadType';
import UserFormFileUploadInputType from './dataTypes/UserFormFileUploadInputType';

import FormFileUploadChildrenType from './dataTypes/FormFileUploadChildrenType';
import FormCheckboxType from './dataTypes/FormCheckboxType';
import UserFormCheckboxType from './dataTypes/UserFormCheckboxType';
import CheckboxChildrenType from './dataTypes/CheckboxChildrenType';
import FormFileUploadErrorMsgType from './dataTypes/FormFileUploadErrorMsgType';
import UserFormUploadErrorMsgType from './dataTypes/UserFormUploadErrorMsgType';
import FormRadioType from './dataTypes/FormRadioType';
import RadioChildrenType from './dataTypes/RadioChildrenType';

import {getUniqueFormIdAndLabel} from '@packages/utilities/platform';
import {Plugins, ElementPreset, Component} from '@packages/systems/wfdl';
import {qualify, iconName} from '@packages/systems/wfdl-Qualified';

import {
  EElement,
  EText,
  ERecord,
  EBoolean,
  EEnum,
  ENumber,
  EList,
  EUnion,
} from '@packages/systems/wfdl-ast';

const FormAddPanelIcon = wrapAddPanelIcon(AddPanelForm64Icon);
const LabelAddPanelIcon = wrapAddPanelIcon(AddPanelLabel64Icon);
const InputAddPanelicon = wrapAddPanelIcon(AddPanelFormInput64Icon);
const UploadAddPanelIcon = wrapAddPanelIcon(AddPanelFormFileUpload64Icon);
const TextareaAddPanelIcon = wrapAddPanelIcon(AddPanelFormTextarea64Icon);
const CheckboxAddPanelIcon = wrapAddPanelIcon(AddPanelFormCheckbox64Icon);
const RadioAddPanelIcon = wrapAddPanelIcon(AddPanelFormRadio64Icon);
const SelectAddPanelIcon = wrapAddPanelIcon(AddPanelFormSelect64Icon);
const ReCaptchaAddPanelIcon = wrapAddPanelIcon(AddPanelFormRecaptcha64Icon);
const SubmitButtonAddPanelicon = wrapAddPanelIcon(AddPanelFormSubmit64Icon);

export const plugin = Plugins.PrivilegedPlugin({
  icons: {
    // Form
    // @ts-expect-error - TS2322 - Type 'ForwardRefExoticComponent<Omit<any, "ref"> & RefAttributes<any>>' is not assignable to type 'ComponentType<IconProps>'.
    AddPanelForm: FormAddPanelIcon,
    FormBlock: FormIcon,
    // Label
    // @ts-expect-error - TS2322 - Type 'ForwardRefExoticComponent<Omit<any, "ref"> & RefAttributes<any>>' is not assignable to type 'ComponentType<IconProps>'.
    AddPanelLabel: LabelAddPanelIcon,
    // FormLabel used [Basic, Text]
    // Select
    // @ts-expect-error - TS2322 - Type 'ForwardRefExoticComponent<Omit<any, "ref"> & RefAttributes<any>>' is not assignable to type 'ComponentType<IconProps>'.
    AddPanelSelect: SelectAddPanelIcon,
    Select: SelectIcon,
    // Checkbox
    // @ts-expect-error - TS2322 - Type 'ForwardRefExoticComponent<Omit<any, "ref"> & RefAttributes<any>>' is not assignable to type 'ComponentType<IconProps>'.
    AddPanelCheckbox: CheckboxAddPanelIcon,
    Checkbox: CheckboxIcon,
    // Text Area
    // @ts-expect-error - TS2322 - Type 'ForwardRefExoticComponent<Omit<any, "ref"> & RefAttributes<any>>' is not assignable to type 'ComponentType<IconProps>'.
    AddPanelTextarea: TextareaAddPanelIcon,
    Textarea: FormTextareaIcon,
    // Input
    // @ts-expect-error - TS2322 - Type 'ForwardRefExoticComponent<Omit<any, "ref"> & RefAttributes<any>>' is not assignable to type 'ComponentType<IconProps>'.
    AddPanelInput: InputAddPanelicon,
    Input: InputIcon,
    // Radio
    // @ts-expect-error - TS2322 - Type 'ForwardRefExoticComponent<Omit<any, "ref"> & RefAttributes<any>>' is not assignable to type 'ComponentType<IconProps>'.
    AddPanelRadio: RadioAddPanelIcon,
    Radio: RadioIcon,
    // Upload
    // @ts-expect-error - TS2322 - Type 'ForwardRefExoticComponent<Omit<any, "ref"> & RefAttributes<any>>' is not assignable to type 'ComponentType<IconProps>'.
    AddPanelUpload: UploadAddPanelIcon,
    Upload: UploadIcon,
    // ReCaptcha
    // @ts-expect-error - TS2322 - Type 'ForwardRefExoticComponent<Omit<any, "ref"> & RefAttributes<any>>' is not assignable to type 'ComponentType<IconProps>'.
    AddPanelReCaptcha: ReCaptchaAddPanelIcon,
    ReCaptcha: ReCaptchaIcon,
    // Button
    // @ts-expect-error - TS2322 - Type 'ForwardRefExoticComponent<Omit<any, "ref"> & RefAttributes<any>>' is not assignable to type 'ComponentType<IconProps>'.
    AddPanelButton: SubmitButtonAddPanelicon,
    // FormButton uses [Basic, Button]
  },
  atoms: {
    FormBlockLabel,
    FormButton,
    FormCheckboxInput,
    FormCheckboxWrapper,
    FormErrorMessage,
    FormForm,
    FormInlineLabel,
    FormRadioInput,
    FormRadioWrapper,
    FormSelect,
    FormSuccessMessage,
    FormTextarea,
    FormTextInput,
    FormWrapper,
    FormReCaptcha,
    FormFileUploadWrapper,
    FormFileUploadDefault,
    FormFileUploadUploading,
    FormFileUploadUploadingBtn,
    FormFileUploadUploadingIcon,
    FormFileUploadSuccess,
    FormFileUploadFile,
    FormFileUploadFileName,
    FormFileUploadRemoveLink,
    FormFileUploadError,
    FormFileUploadErrorMsg,
    UserFormUploadErrorMsg,
    FormFileUploadInput,
    FormFileUploadLabel,
    FormFileUploadInfo,
    FormFileUploadText,
  },
  components: {
    FormButtonComponent,
  },
  dataTypes: {
    FormForm: FormFormType,
    FormFormChildren: FormFormChildrenType,
    FormFileUpload: FormFileUploadType,
    UserFormFileUploadInput: UserFormFileUploadInputType,
    FormFileUploadChildren: FormFileUploadChildrenType,
    FormRadio: FormRadioType,
    RadioChildren: RadioChildrenType,
    FormCheckbox: FormCheckboxType,
    UserFormCheckbox: UserFormCheckboxType,
    CheckboxChildren: CheckboxChildrenType,
    FormSelect: FormSelectType,
    UserFormSelect: UserFormSelectType,
    FormTextInput: FormTextInputType,
    UserFormTextInput: UserFormTextInputType,
    FormTextarea: FormTextAreaType,
    FormSelectOption,
    FormFileUploadErrorMsg: FormFileUploadErrorMsgType,
    UserFormUploadErrorMsg: UserFormUploadErrorMsgType,
  },
  elementPresets: {
    FormForm: ElementPreset.create({
      icon: {
        small: qualify(Plugins.name('Form'), iconName('FormBlock')),
        medium: qualify(Plugins.name('Form'), iconName('AddPanelForm')),
      },
      label: 'Form Block',

      factory: ({componentMap, betaFeatures}) => {
        if (componentMap === undefined) {
          throw Error(
            'componentMap is required to instantiate FormBlock elementPreset'
          );
        }

        if (betaFeatures === undefined) {
          betaFeatures = {};
        }

        const hasPluginComponentsEnabled =
          betaFeatures.pluginComponents === true;

        const formID = getUniqueFormIdAndLabel(componentMap, 'email-form');
        const nameID = getUniqueFormIdAndLabel(componentMap, 'name');
        const emailID = getUniqueFormIdAndLabel(componentMap, 'email');

        return EElement({
          id: 'Form Wrapper',
          type: qualify(Plugins.name('Form'), Component.name('FormWrapper')),
          data: ERecord({
            form: ERecord({
              type: EText('wrapper'),
            }),
            children: EList([
              EElement({
                id: 'Form Form',
                type: qualify(Plugins.name('Form'), Component.name('FormForm')),
                data: ERecord({
                  attr: ERecord({
                    id: EText(formID.id),
                    name: EText(formID.id),
                    'data-name': EText(formID.label),
                    redirect: EText(''),
                    'data-redirect': EText(''),
                    'data-wf-close-modal': EBoolean(false),
                    action: EText(''),
                    method: EEnum('get'),
                  }),
                  Source: EUnion({tag: 'Default form', value: ERecord({})}),
                  form: ERecord({
                    type: EText('form'),
                    name: EText(formID.label),
                  }),
                  temp: ERecord({
                    state: EEnum('normal'),
                    'password-state': EEnum('normal'),
                  }),

                  children: EList([
                    EElement({
                      id: 'Form Block Label',
                      type: qualify(
                        Plugins.name('Form'),
                        Component.name('FormBlockLabel')
                      ),
                      data: ERecord({
                        form: ERecord({
                          type: EText('label'),
                          passwordPage: EBoolean(false),
                        }),
                        attr: ERecord({
                          for: EText('name'),
                        }),
                        children: EList([
                          EElement({
                            id: 'Form Wrapper String',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('String')
                            ),
                            data: EText('Name'),
                          }),
                        ]),
                      }),
                    }),
                    EElement({
                      id: 'Form Text Input',
                      type: qualify(
                        Plugins.name('Form'),
                        Component.name('FormTextInput')
                      ),
                      data: ERecord({
                        attr: ERecord({
                          autofocus: EBoolean(false),
                          maxlength: ENumber(256),
                          name: EText(nameID.id),
                          'data-name': EText(nameID.label),
                          placeholder: EText(''),
                          type: EEnum('text'),
                          id: EText(nameID.id),
                          disabled: EBoolean(false),
                          required: EBoolean(false),
                        }),
                        form: ERecord({
                          type: EText('input'),
                          name: EText(nameID.label),
                          passwordPage: EBoolean(false),
                        }),
                      }),
                    }),
                    EElement({
                      id: 'Form Block Label 2',
                      type: qualify(
                        Plugins.name('Form'),
                        Component.name('FormBlockLabel')
                      ),
                      data: ERecord({
                        form: ERecord({
                          type: EText('label'),
                          passwordPage: EBoolean(false),
                        }),
                        attr: ERecord({
                          for: EText('email'),
                        }),
                        children: EList([
                          EElement({
                            id: 'Form Wrapper String 2',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('String')
                            ),
                            data: EText('Email Address'),
                          }),
                        ]),
                      }),
                    }),
                    EElement({
                      id: 'Form Text Input 2',
                      type: qualify(
                        Plugins.name('Form'),
                        Component.name('FormTextInput')
                      ),
                      data: ERecord({
                        attr: ERecord({
                          autofocus: EBoolean(false),
                          maxlength: ENumber(256),
                          name: EText(emailID.id),
                          'data-name': EText(emailID.label),
                          placeholder: EText(''),
                          type: EEnum('email'),
                          id: EText(emailID.id),
                          disabled: EBoolean(false),
                          required: EBoolean(true),
                        }),
                        form: ERecord({
                          type: EText('input'),
                          name: EText(emailID.label),
                          passwordPage: EBoolean(false),
                        }),
                      }),
                    }),
                    hasPluginComponentsEnabled
                      ? EElement({
                          id: 'Form Button',
                          type: qualify(
                            Plugins.name('Form'),
                            Component.name('FormButtonComponent')
                          ),
                          data: ERecord({
                            value: EText('Submit'),
                            'data-wait': EText('Please wait...'),
                          }),
                        })
                      : EElement({
                          id: 'Form Button',
                          type: qualify(
                            Plugins.name('Form'),
                            Component.name('FormButton')
                          ),
                          data: ERecord({
                            attr: ERecord({
                              type: EText('submit'),
                              value: EText('Submit'),
                              'data-wait': EText('Please wait...'),
                            }),
                            form: ERecord({
                              type: EText('button'),
                            }),
                            eventIds: EList([]),
                          }),
                        }),
                  ]),
                }),
              }),
              EElement({
                id: 'Form Success Message',
                type: qualify(
                  Plugins.name('Form'),
                  Component.name('FormSuccessMessage')
                ),
                data: ERecord({
                  form: ERecord({
                    type: EText('msg-done'),
                  }),
                  children: EList([
                    EElement({
                      id: 'Form Wrapper Block',
                      type: qualify(
                        Plugins.name('Basic'),
                        Component.name('Block')
                      ),
                      data: ERecord({
                        tag: EEnum('div'),
                        text: EBoolean(true),
                        children: EList([
                          EElement({
                            id: 'Form Wrapper String 3',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('String')
                            ),
                            data: EText(
                              'Thank you! Your submission has been received!'
                            ),
                          }),
                        ]),
                      }),
                    }),
                  ]),
                }),
              }),
              EElement({
                id: 'Form Error Message',
                type: qualify(
                  Plugins.name('Form'),
                  Component.name('FormErrorMessage')
                ),
                data: ERecord({
                  form: ERecord({
                    type: EText('msg-fail'),
                  }),
                  children: EList([
                    EElement({
                      id: 'Form Wrapper Block 2',
                      type: qualify(
                        Plugins.name('Basic'),
                        Component.name('Block')
                      ),
                      data: ERecord({
                        tag: EEnum('div'),
                        text: EBoolean(true),
                        children: EList([
                          EElement({
                            id: 'Form Wrapper String 4',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('String')
                            ),
                            data: EText(
                              'Oops! Something went wrong while submitting the form.'
                            ),
                          }),
                        ]),
                      }),
                    }),
                  ]),
                }),
              }),
            ]),
          }),
        });
      },
      helpData: {
        tag: 'form',
        description: [
          'A Form block groups form elements, like checkboxes and buttons. You can view submissions or set up email notifications for form submissions in settings.',
          'Or, if you use Webflow CMS, you can also view form submissions in the Editor.',
        ],
        tip: 'Double-click on a Form Block to switch between the form’s normal, success, and error states.',
        videoSrc:
          'https://d3e54v103j8qbb.cloudfront.net/videos/tooltips/form-block.c9bb00514e.mp4',
      },
      category: 'Forms',
    }),
    FormBlockLabel: ElementPreset.create({
      icon: {
        small: qualify(Plugins.name('Basic'), iconName('Text')),
        medium: qualify(Plugins.name('Form'), iconName('AddPanelLabel')),
      },
      label: 'Label',
      factory: EElement({
        id: 'Form Block Label',
        type: qualify(Plugins.name('Form'), Component.name('FormBlockLabel')),
        data: ERecord({
          attr: ERecord({
            for: EText(''),
          }),
          form: ERecord({
            type: EText('label'),
            passwordPage: EBoolean(false),
          }),
          children: EList([
            EElement({
              id: 'Form Wrapper String',
              type: qualify(Plugins.name('Basic'), Component.name('String')),
              data: EText('Form Label'),
            }),
          ]),
        }),
      }),
      helpData: {
        tag: 'label',
        description: [
          'Labels help your visitors understand what a field is for (e.g., Full name, Email address, etc.).',
        ],
        videoSrc:
          'https://d3e54v103j8qbb.cloudfront.net/videos/tooltips/label.0db21fda46.mp4',
      },
      category: 'Forms',
    }),
    FormTextInput: ElementPreset.create({
      icon: {
        small: qualify(Plugins.name('Form'), iconName('Input')),
        medium: qualify(Plugins.name('Form'), iconName('AddPanelInput')),
      },
      label: 'Input',

      factory: ({componentMap}) => {
        if (componentMap === undefined) {
          throw Error(
            'componentMap is required to instantiate FormTextInput elementPreset'
          );
        }
        const {id, label} = getUniqueFormIdAndLabel(componentMap, 'field');

        return EElement({
          id: 'Form Text Input',
          type: qualify(Plugins.name('Form'), Component.name('FormTextInput')),
          data: ERecord({
            attr: ERecord({
              autofocus: EBoolean(false),
              maxlength: ENumber(256),
              name: EText(id),
              'data-name': EText(label),
              placeholder: EText('Example Text'),
              type: EEnum('text'),
              id: EText(id),
              disabled: EBoolean(false),
              required: EBoolean(true),
            }),
            form: ERecord({
              type: EText('input'),
              name: EText(label),
              passwordPage: EBoolean(false),
            }),
          }),
        });
      },
      helpData: {
        tag: 'input type="text"',
        description: [
          'Use Input to collect information from your visitors — like name, email address, favorite color, dog’s name, etc.',
        ],
        tip: 'Make your site more accessible by adding placeholder text to help visitors understand what to include in their entry.',
        videoSrc:
          'https://d3e54v103j8qbb.cloudfront.net/videos/tooltips/input.5465541441.mp4',
      },
      category: 'Forms',
    }),
    FormFileUploadWrapper: ElementPreset.create({
      icon: {
        small: qualify(Plugins.name('Form'), iconName('Upload')),
        medium: qualify(Plugins.name('Form'), iconName('AddPanelUpload')),
      },
      label: 'File Upload',
      enableIfFlag: 'allowFormFileUpload',
      needsUpgrade: {
        relativeUpgradeUrl: ({
          siteSlug,
        }: ElementPreset.ElementPresetUpgradeLinkProps) => {
          if (siteSlug === undefined) {
            return `/pricing`;
          }
          return `/dashboard/sites/${siteSlug}/hosting?ref=add_form_fileupload&u=business`;
        },
        disabledMessage:
          'This element requires an eligible Site plan. Click the star icon to upgrade your plan.',
      },

      factory: ({componentMap}) => {
        if (componentMap === undefined) {
          throw Error(
            'componentMap is required to instantiate FormFileUploadWrapper elementPreset'
          );
        }
        const {id, label} = getUniqueFormIdAndLabel(componentMap, 'file');
        return EElement({
          id: 'Form File Upload Wrapper',
          type: qualify(
            Plugins.name('Form'),
            Component.name('FormFileUploadWrapper')
          ),
          data: ERecord({
            form: ERecord({
              type: EText('file-upload'),
            }),
            children: EList([
              EElement({
                id: 'Form File Upload Default',
                type: qualify(
                  Plugins.name('Form'),
                  Component.name('FormFileUploadDefault')
                ),
                data: ERecord({
                  form: ERecord({
                    type: EText('file-upload-default'),
                  }),
                  children: EList([
                    EElement({
                      id: 'Form File Upload Input',
                      type: qualify(
                        Plugins.name('Form'),
                        Component.name('FormFileUploadInput')
                      ),
                      data: ERecord({
                        temp: ERecord({state: EEnum('default')}),
                        attr: ERecord({
                          multiple: EBoolean(false),
                          required: EBoolean(false),
                          type: EText('file'),
                          id: EText(id),
                          name: EText(id),
                          'data-name': EText(label),
                          accept: EText(''),
                          'aria-hidden': EText('true'),
                          tabIndex: EText('-1'),
                        }),
                        form: ERecord({
                          acceptCustom: EBoolean(false),
                          acceptDocuments: EBoolean(false),
                          acceptImages: EBoolean(false),
                          customTypes: EText(''),
                          manageTypes: EBoolean(false),
                          type: EText('file-upload-input'),
                          name: EText(label),
                        }),
                      }),
                    }),
                    EElement({
                      id: 'Form File Upload Label',
                      type: qualify(
                        Plugins.name('Form'),
                        Component.name('FormFileUploadLabel')
                      ),
                      data: ERecord({
                        form: ERecord({
                          type: EText('file-upload-label'),
                        }),
                        attr: ERecord({
                          for: EText('file'),
                          role: EText('button'),
                          tabIndex: EText('0'),
                        }),
                        children: EList([
                          EElement({
                            id: 'Icon',
                            type: qualify(
                              Plugins.name('Icon'),
                              Component.name('Icon')
                            ),
                            data: ERecord({
                              widget: ERecord({
                                type: EText('icon'),
                                icon: EText('file-upload-icon'),
                              }),
                              children: EList([]),
                            }),
                          }),
                          EElement({
                            id: 'Form File Upload Text',
                            type: qualify(
                              Plugins.name('Form'),
                              Component.name('FormFileUploadText')
                            ),
                            data: ERecord({
                              text: EBoolean(true),
                              children: EList([
                                EElement({
                                  id: 'String',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('String')
                                  ),
                                  data: EText('Upload File'),
                                }),
                              ]),
                            }),
                          }),
                        ]),
                      }),
                    }),
                    EElement({
                      id: 'Form File Upload Info',
                      type: qualify(
                        Plugins.name('Form'),
                        Component.name('FormFileUploadInfo')
                      ),
                      data: ERecord({
                        text: EBoolean(true),
                        form: ERecord({
                          type: EText('file-upload-info'),
                        }),
                        children: EList([
                          EElement({
                            id: 'String 2',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('String')
                            ),
                            data: EText('Max file size 10MB.'),
                          }),
                        ]),
                      }),
                    }),
                  ]),
                }),
              }),
              EElement({
                id: 'Form File Upload Uploading',
                type: qualify(
                  Plugins.name('Form'),
                  Component.name('FormFileUploadUploading')
                ),
                data: ERecord({
                  form: ERecord({
                    type: EText('file-upload-uploading'),
                  }),
                  children: EList([
                    EElement({
                      id: 'Form File Upload Uploading Button',
                      type: qualify(
                        Plugins.name('Form'),
                        Component.name('FormFileUploadUploadingBtn')
                      ),
                      data: ERecord({
                        form: ERecord({
                          type: EText('file-upload-uploading-btn'),
                        }),
                        children: EList([
                          EElement({
                            id: 'Form File Upload Uploading Icon',
                            type: qualify(
                              Plugins.name('Form'),
                              Component.name('FormFileUploadUploadingIcon')
                            ),
                            data: ERecord({
                              widget: ERecord({
                                type: EText('icon'),
                              }),
                            }),
                          }),
                          EElement({
                            id: 'Form File Upload Text 2',
                            type: qualify(
                              Plugins.name('Form'),
                              Component.name('FormFileUploadText')
                            ),
                            data: ERecord({
                              text: EBoolean(true),
                              children: EList([
                                EElement({
                                  id: 'String 3',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('String')
                                  ),
                                  data: EText('Uploading...'),
                                }),
                              ]),
                            }),
                          }),
                        ]),
                      }),
                    }),
                  ]),
                }),
              }),
              EElement({
                id: 'Form File Upload Success',
                type: qualify(
                  Plugins.name('Form'),
                  Component.name('FormFileUploadSuccess')
                ),
                data: ERecord({
                  form: ERecord({
                    type: EText('file-upload-success'),
                  }),
                  children: EList([
                    EElement({
                      id: 'Form File Upload File',
                      type: qualify(
                        Plugins.name('Form'),
                        Component.name('FormFileUploadFile')
                      ),
                      data: ERecord({
                        form: ERecord({
                          type: EText('file-upload-file'),
                        }),
                        children: EList([
                          EElement({
                            id: 'Form File Upload File Name',
                            type: qualify(
                              Plugins.name('Form'),
                              Component.name('FormFileUploadFileName')
                            ),
                            data: ERecord({
                              text: EBoolean(true),
                              form: ERecord({
                                type: EText('file-upload-file-name'),
                              }),
                            }),
                          }),
                          EElement({
                            id: 'Form File Upload Remove Link',
                            type: qualify(
                              Plugins.name('Form'),
                              Component.name('FormFileUploadRemoveLink')
                            ),
                            data: ERecord({
                              form: ERecord({
                                type: EText('file-upload-remove-link'),
                              }),
                              children: EList([
                                EElement({
                                  id: 'Icon 2',
                                  type: qualify(
                                    Plugins.name('Icon'),
                                    Component.name('Icon')
                                  ),
                                  data: ERecord({
                                    widget: ERecord({
                                      type: EText('icon'),
                                      icon: EText('file-upload-remove'),
                                    }),
                                    children: EList([]),
                                  }),
                                }),
                              ]),
                            }),
                          }),
                        ]),
                      }),
                    }),
                  ]),
                }),
              }),
              EElement({
                id: 'Form File Upload Error',
                type: qualify(
                  Plugins.name('Form'),
                  Component.name('FormFileUploadError')
                ),
                data: ERecord({
                  form: ERecord({
                    type: EText('file-upload-error'),
                  }),
                  children: EList([
                    EElement({
                      id: 'Form File Upload Error Message',
                      type: qualify(
                        Plugins.name('Form'),
                        Component.name('FormFileUploadErrorMsg')
                      ),
                      data: ERecord({
                        text: EBoolean(true),
                        temp: ERecord({
                          state: EText('SIZE_ERROR'),
                        }),
                        form: ERecord({
                          SIZE_ERROR: EText(
                            'Upload failed. Max size for files is 10 MB.'
                          ),
                          TYPE_ERROR: EText(
                            'Upload failed. Invalid file type.'
                          ),
                          GENERIC_ERROR: EText(
                            'Upload failed. Something went wrong. Please retry.'
                          ),
                          type: EText('file-upload-error-msg'),
                        }),
                      }),
                    }),
                  ]),
                }),
              }),
            ]),
          }),
        });
      },
      helpData: {
        tag: 'input type="file"',
        description: [
          'Allow site visitors to attach files to a form, like a screenshot or resume. Customize the file types you’ll accept — PDF, .docx, etc. — in your settings.',
          'PS: This feature is only available with an Ecommerce Plus, Advanced, or Business Site plan',
        ],
        videoSrc:
          'https://d3e54v103j8qbb.cloudfront.net/videos/tooltips/file-upload.10f4171eeb.mp4',
      },
      category: 'Forms',
    }),
    FormTextarea: ElementPreset.create({
      icon: {
        small: qualify(Plugins.name('Form'), iconName('Textarea')),
        medium: qualify(Plugins.name('Form'), iconName('AddPanelTextarea')),
      },
      label: 'Text Area',

      factory: ({componentMap}) => {
        if (componentMap === undefined) {
          throw Error(
            'componentMap is required to instantiate FormTextArea elementPreset'
          );
        }
        const {id, label} = getUniqueFormIdAndLabel(componentMap, 'field');
        return EElement({
          id: 'Form Textarea',
          type: qualify(Plugins.name('Form'), Component.name('FormTextarea')),
          data: ERecord({
            attr: ERecord({
              required: EBoolean(false),
              autofocus: EBoolean(false),
              placeholder: EText('Example Text'),
              maxlength: ENumber(5000),
              id: EText(id),
              name: EText(id),
              'data-name': EText(label),
            }),
            form: ERecord({
              type: EText('textarea'),
              name: EText(label),
            }),
            children: EList([]),
          }),
        });
      },
      helpData: {
        tag: 'textarea',
        description: [
          'Text areas are a middle-ground between paragraph text and single-line text. Perfect for use in a “contact us” message.',
        ],
        tip: 'Add placeholder text to help visitors understand what to include in their entry.',
        videoSrc:
          'https://d3e54v103j8qbb.cloudfront.net/videos/tooltips/text-area.611474441d.mp4',
      },
      category: 'Forms',
    }),
    FormCheckboxInput: ElementPreset.create({
      icon: {
        small: qualify(Plugins.name('Form'), iconName('Checkbox')),
        medium: qualify(Plugins.name('Form'), iconName('AddPanelCheckbox')),
      },
      label: 'Checkbox',

      factory: ({componentMap}) => {
        if (componentMap === undefined) {
          throw Error(
            'componentMap is required to instantiate FormCheckboxInput elementPreset'
          );
        }
        const {label, id} = getUniqueFormIdAndLabel(componentMap, 'checkbox');
        return EElement({
          id: 'Form Checkbox Wrapper',
          type: qualify(
            Plugins.name('Form'),
            Component.name('FormCheckboxWrapper')
          ),
          data: ERecord({
            form: ERecord({
              type: EText('checkbox'),
            }),
            children: EList([
              EElement({
                id: 'Form Checkbox Input',
                type: qualify(
                  Plugins.name('Form'),
                  Component.name('FormCheckboxInput')
                ),
                data: ERecord({
                  attr: ERecord({
                    type: EText('checkbox'),
                    id: EText(id),
                    name: EText(id),
                    'data-name': EText(label),
                    checked: EBoolean(false),
                    required: EBoolean(false),
                  }),
                  inputType: EEnum('default'),
                  form: ERecord({
                    type: EText('checkbox-input'),
                    name: EText(label),
                  }),
                  temp: ERecord({
                    checkbox: ERecord({
                      isChecked: EBoolean(false),
                      isFocused: EBoolean(false),
                      isFocusedVisible: EBoolean(false),
                    }),
                  }),
                }),
              }),
              EElement({
                id: 'Form Inline Label',
                type: qualify(
                  Plugins.name('Form'),
                  Component.name('FormInlineLabel')
                ),
                data: ERecord({
                  form: ERecord({
                    type: EText('checkbox-label'),
                  }),
                  children: EList([
                    EElement({
                      id: 'Form Wrapper String',
                      type: qualify(
                        Plugins.name('Basic'),
                        Component.name('String')
                      ),
                      data: EText(label),
                    }),
                  ]),
                }),
              }),
            ]),
          }),
        });
      },
      helpData: {
        tag: 'input type="checkbox"',
        description: [
          'Checkboxes allow site visitors to, well, check boxes. These are good for yes or no questions, or for allowing visitors to select multiple options at once.',
        ],
        videoSrc:
          'https://d3e54v103j8qbb.cloudfront.net/videos/tooltips/checkbox.dc1757d8ec.mp4',
      },
      category: 'Forms',
    }),
    FormRadioInput: ElementPreset.create({
      icon: {
        small: qualify(Plugins.name('Form'), iconName('Radio')),
        medium: qualify(Plugins.name('Form'), iconName('AddPanelRadio')),
      },
      label: 'Radio Button',

      factory: ({componentMap}) => {
        if (componentMap === undefined) {
          throw Error(
            'componentMap is required to instantiate FormRadioInput elementPreset'
          );
        }
        const inputID = getUniqueFormIdAndLabel(componentMap, 'radio');
        return EElement({
          id: 'Form Radio Wrapper',
          type: qualify(
            Plugins.name('Form'),
            Component.name('FormRadioWrapper')
          ),
          data: ERecord({
            form: ERecord({
              type: EText('radio'),
            }),
            children: EList([
              EElement({
                id: 'Form Radio Input',
                type: qualify(
                  Plugins.name('Form'),
                  Component.name('FormRadioInput')
                ),
                data: ERecord({
                  inputType: EEnum('default'),
                  attr: ERecord({
                    type: EText('radio'),
                    'data-name': EText(inputID.label),
                    id: EText(inputID.id),
                    name: EText(inputID.id),
                    value: EText(inputID.label),
                    required: EBoolean(false),
                  }),
                  form: ERecord({
                    type: EText('radio-input'),
                    name: EText(inputID.label),
                  }),
                  temp: ERecord({
                    checkbox: ERecord({
                      isChecked: EBoolean(false),
                      isFocused: EBoolean(false),
                      isFocusedVisible: EBoolean(false),
                    }),
                  }),
                }),
              }),
              EElement({
                id: 'Form Inline Label',
                type: qualify(
                  Plugins.name('Form'),
                  Component.name('FormInlineLabel')
                ),
                data: ERecord({
                  form: ERecord({
                    type: EText('radio-label'),
                  }),
                  children: EList([
                    EElement({
                      id: 'Form Wrapper String',
                      type: qualify(
                        Plugins.name('Basic'),
                        Component.name('String')
                      ),
                      data: EText(inputID.label),
                    }),
                  ]),
                }),
              }),
            ]),
          }),
        });
      },
      helpData: {
        tag: 'input type="radio"',
        description: [
          'Radio buttons allow visitors to select a single option among multiple options.',
        ],
        videoSrc:
          'https://d3e54v103j8qbb.cloudfront.net/videos/tooltips/radio-button.8d9677d1f4.mp4',
      },
      category: 'Forms',
    }),
    FormSelect: ElementPreset.create({
      icon: {
        small: qualify(Plugins.name('Form'), iconName('Select')),
        medium: qualify(Plugins.name('Form'), iconName('AddPanelSelect')),
      },
      label: 'Select',

      factory: ({componentMap}) => {
        if (componentMap === undefined) {
          throw Error(
            'componentMap is required to instantiate FormSelect elementPreset'
          );
        }
        const {id, label} = getUniqueFormIdAndLabel(componentMap, 'field');
        return EElement({
          id: 'Form Select',
          type: qualify(Plugins.name('Form'), Component.name('FormSelect')),
          data: ERecord({
            attr: ERecord({
              id: EText(id),
              name: EText(id),
              'data-name': EText(label),
              required: EBoolean(false),
              multiple: EBoolean(false),
            }),
            form: ERecord({
              type: EText('select'),
              opts: EList([
                ERecord({
                  v: EText(''),
                  t: EText('Select one...'),
                }),
                ERecord({
                  v: EText('First'),
                  t: EText('First choice'),
                }),
                ERecord({
                  v: EText('Second'),
                  t: EText('Second choice'),
                }),
                ERecord({
                  v: EText('Third'),
                  t: EText('Third choice'),
                }),
              ]),
              name: EText(label),
            }),
          }),
        });
      },
      helpData: {
        tag: 'select',
        description: [
          'Allow visitors to select options — either one or multiple — from a dropdown menu.',
        ],
        videoSrc:
          'https://d3e54v103j8qbb.cloudfront.net/videos/tooltips/select.0321923866.mp4',
      },
      category: 'Forms',
    }),
    FormReCaptcha: ElementPreset.create({
      icon: {
        small: qualify(Plugins.name('Form'), iconName('ReCaptcha')),
        medium: qualify(Plugins.name('Form'), iconName('AddPanelReCaptcha')),
      },
      label: 'reCAPTCHA',
      factory: EElement({
        id: 'Form ReCaptcha',
        type: qualify(Plugins.name('Form'), Component.name('FormReCaptcha')),
        data: ERecord({
          form: ERecord({
            type: EText('recaptcha'),
          }),
        }),
      }),
      helpData: {
        description: [
          'reCAPTCHA protects your website from spam and abuse. It makes sure a form is only submitted by humans.',
          'PS: If reCAPTCHA is used on one form, it must be used on all forms.',
        ],
        tip: 'For this to work properly, it needs extra attention in Settings.',
        link: {
          text: 'Learn more.',
          href: 'https://university.webflow.com/lesson/recaptcha',
        },
        videoSrc:
          'https://d3e54v103j8qbb.cloudfront.net/videos/tooltips/ReCAPTCHA.b6df1bff8a.mp4',
      },
      category: 'Forms',
    }),
    FormButton: ElementPreset.create({
      icon: {
        small: qualify(Plugins.name('Basic'), iconName('Button')),
        medium: qualify(Plugins.name('Form'), iconName('AddPanelButton')),
      },
      label: 'Form Button',
      factory: EElement({
        id: 'Form Button',
        type: qualify(Plugins.name('Form'), Component.name('FormButton')),
        data: ERecord({
          attr: ERecord({
            type: EText('submit'),
            value: EText('Submit'),
            'data-wait': EText('Please wait...'),
          }),
          form: ERecord({
            type: EText('button'),
          }),
          eventIds: EList([]),
        }),
      }),
      helpData: {
        description: [
          'Visitors click the Form button to submit a completed form.',
        ],
        videoSrc:
          'https://d3e54v103j8qbb.cloudfront.net/videos/tooltips/form-button.3e446d08a7.mp4',
      },
      category: 'Forms',
    }),
    FormButtonComponent: ElementPreset.create({
      icon: {
        small: qualify(Plugins.name('Basic'), iconName('Button')),
        medium: qualify(Plugins.name('Form'), iconName('AddPanelButton')),
      },
      label: 'Form Button Component',
      factory: EElement({
        id: 'Form Button',
        type: qualify(
          Plugins.name('Form'),
          Component.name('FormButtonComponent')
        ),
        data: ERecord({
          value: EText('Submit'),
          'data-wait': EText('Please wait...'),
        }),
      }),
      helpData: {
        description: [
          'Visitors click the Form button to submit a completed form.',
        ],
        videoSrc:
          'https://d3e54v103j8qbb.cloudfront.net/videos/tooltips/form-button.3e446d08a7.mp4',
      },
      category: 'Forms',
      beta: {enabledBasedOnFlags: {betaFlagName: 'pluginComponents'}},
    }),
  },
  siteModules: [
    {
      filePaths: [path.resolve(__dirname, 'webflow-forms.js')],
      bundleIf: {
        type: 'node',
        test: ({data = {}}) =>
          data.form &&
          (data.form.type === 'wrapper' || data.form.type === 'form'),
      },
    },
  ],
});
